import { render, staticRenderFns } from "./ShopEntry.vue?vue&type=template&id=516be7f0&scoped=true"
import script from "./ShopEntry.vue?vue&type=script&lang=js"
export * from "./ShopEntry.vue?vue&type=script&lang=js"
import style0 from "./ShopEntry.vue?vue&type=style&index=0&id=516be7f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516be7f0",
  null
  
)

export default component.exports